import { sentimentNumber } from '../../render-helper';

export default function feedsKeywordTableColumns(params: any) {
  const { hideSentimentRating } = params;
  const list = [
    {
      header: 'Keyword',
      render: 'keyword',
    },
    {
      header: 'Keyword ZH',
      render: 'keyword_cn',
    },
    {
      header: 'Keyword EN',
      render: 'keyword_en',
    },
    {
      header: 'Sentiment',
      render: 'sentiment_rating',
      renderHelper: [sentimentNumber],
    },
    { header: 'Reviews', render: 'count' },
  ];

  if (hideSentimentRating) {
    return list.filter((item) => item.render !== 'sentiment_rating');
  }

  return list;
}
